module.exports = __webpack_public_path__ + "assets/img/26.e1ce58e5.png";